import "./contact.css";
import Phone from "../../img/phone.png";
import Email from "../../img/email.png";
import Address from "../../img/address.png";
import Github from "../../img/github.png";
import Linkedin from "../../img/linkedIn.png";
import { useContext, useRef, useState } from "react";
import emailjs from "emailjs-com";
import { ThemeContext } from "../../context";

const Contact = () => {
  const formRef = useRef();
  //  const [done, setDone] = useState(false)
  const theme = useContext(ThemeContext);
  const darkMode = theme.state.darkMode;
  
  const handleSubmit = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_tn7qsvj",
        "template_5smihal",
        formRef.current,
        "user_u1pySjNB6dw71EDu5U1wt"
      )
      .then(
        (result) => {
          console.log(result.text);
          e = "";
          alert("Successfully Submitted");
          // setDone(true)
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  return (
    <div className="c" id="contact">
      {/* <div className="c-bg"></div> */}
      <div className="c-wrapper">
        <div className="c-left">
          <h1 className="c-title">Connect with me:</h1>
          <div className="c-info">
            <div className="c-info-item">
              <img src={Phone} alt="" className="c-icon" />
              <a href="tel:+918129150582" target="_blank" className={darkMode ? "white_clr":"black_clr"}>
              +91 8129150582 </a>
            </div>
            <div className="c-info-item">
              <img className="c-icon" src={Email} alt="" />
              <a href="mailto:sameel555@gmail.com" target="_blank" className={darkMode ? "white_clr":"black_clr"}>
                   sameel555@gmail.com
              </a>
              
            </div>
          <div className="c-info-item">
            
              <img className="c-icon" src={Github} alt="" />
               <a href="https://github.com/sameel555" target="_blank" className={darkMode ? "white_clr":"black_clr"}>
                sameel555
                 </a>
            </div>
            <div className="c-info-item">
            
              <img className="c-icon" src={Linkedin} alt=""  />
              <a href="https://www.linkedin.com/in/sameel-paikadan-8b058814b/" target="_blank" className={darkMode ? "white_clr":"black_clr"}>
              sameel-paikadan-8b058814b
               </a>
            </div>
            <div className="c-info-item">
              <img className="c-icon" src={Address} alt="" />
               <a href="https://goo.gl/maps/jDvHLkdCX5s9FRkg9" target="_blank" className={darkMode ? "white_clr":"black_clr"}>
              Malappuram,Kerala,India </a>
            </div>
          </div>
        </div>
        <div className="c-right">
          <p className="c-desc">
            <b>Get in touch: </b> Always available for
            freelancing if the right project comes along me.
          </p>
          <form ref={formRef} onSubmit={handleSubmit}>
            <input style={{backgroundColor: darkMode && "#333"}} type="text" placeholder="Name" name="user_name" />
            <input style={{backgroundColor: darkMode && "#333"}} type="text" placeholder="Subject" name="user_subject" />
            <input style={{backgroundColor: darkMode && "#333"}} type="text" placeholder="Email" name="user_email" />
            <textarea style={{backgroundColor: darkMode && "#333"}} rows="5" placeholder="Message" name="message" />
            <button onClick={handleSubmit}>Submit</button>
           
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;
